import gql from "graphql-tag";

export const GetOpportunities = gql`
  query GetOpportunities($id: String, $product: QueryableProduct) {
    opportunities(opportunity: { id: $id, product: $product }) {
      id
      amount
      isPercentage
      isActive
      expiresAt

      stats {
        influencers
        applicants
        videos
        earnings
      }

      product {
        id
        name
        price
        isDonation
        images {
          id
          url
        }
      }
    }
  }
`;
